export default __webpack_public_path__ + "static/media/file-upload.9ed52c83.svg";